export default {
    flatMenuItems: state => {
        const categoryMap =
            state.categoryMap instanceof Map ? state.categoryMap : new Map()

        if (!Array.isArray(state.items)) return []

        return state.items.map(item => ({
            ...item,
            category_name:
                item.category_name ?? categoryMap.get(item.parent_id) ?? null,
        }))
    },
    stopListCount: state => state.lastKnownStoppedCount,

    filteredItems: state => {
        const categoryMap =
            state.categoryMap instanceof Map ? state.categoryMap : new Map()
        const selectedIds = state.printManagement.selectedPrintLocationIds

        // Helper to enrich items with category_name
        const enrichItems = items =>
            items.map(item => ({
                ...item,
                category_name:
                    item.category_name ?? categoryMap.get(item.parent_id) ?? null,
            }))

        // If nothing selected - show all
        if (!selectedIds || selectedIds.length === 0) {
            return enrichItems(state.items)
        }

        // First, filter dishes by print locations
        const filteredDishes = state.items.filter(item => {
            if (item.type !== 'dish') {
                return false
            }

            if (!item.print_locations || item.print_locations.length === 0) {
                return false
            }

            return item.print_locations.some(loc =>
                selectedIds.includes(loc.id)
            )
        })

        // Build set of category IDs that have matching dishes
        const categoriesWithDishes = new Set()
        filteredDishes.forEach(dish => {
            if (dish.parent_id) {
                categoriesWithDishes.add(dish.parent_id)
            }
        })

        // Filter items: show dishes that match + categories that have matching dishes
        const filteredDishIds = new Set(filteredDishes.map(d => d.id))

        const filteredResult = state.items.filter(item => {
            if (item.type === 'dish') {
                // Include if dish matches print location filter
                return filteredDishIds.has(item.id)
            }
            // Include category only if it has matching dishes
            return categoriesWithDishes.has(item.id)
        })

        return enrichItems(filteredResult)
    },

    printLocationsWithCounts: state => {
        return state.printManagement.printLocations.map(location => ({
            ...location,
            count: state.items.filter(item =>
                item.type === 'dish' &&
                item.print_locations?.some(loc => loc.id === location.id)
            ).length
        }))
    },
}
